import useKeyConversion from '~/composables/useKeyConversion';

/**
 * Normalises a teaser payload from the Lantern delivery API
 * (`.../v2/teaser-article/:id`), which returns snake_case and no
 * longer computes the `external` flag. This previously ran in the
 * CPP `teaser-article` server route; it now runs client-side, per
 * teaser-consuming component.
 */
export function transformTeaser (data: any) {
  if (!data || typeof data !== 'object' || Array.isArray(data) || Object.keys(data).length === 0) {
    return data;
  }
  const converted = useKeyConversion('camel').convertKeys(data);
  converted.external = !converted.canonicalSlug?.includes('/2-');
  return converted;
}
